module.exports = {
          srcSet: __webpack_public_path__ + "97e158b297deb44b955da6827579cc63-60.png"+" 60w",
          images:[ {path: __webpack_public_path__ + "97e158b297deb44b955da6827579cc63-60.png",width: 60,height: 46}],
          src: __webpack_public_path__ + "97e158b297deb44b955da6827579cc63-60.png",
          toString:function(){return __webpack_public_path__ + "97e158b297deb44b955da6827579cc63-60.png"},
          
          width: 60,
          height: 46
        }